<template>
  <div>
    <insulin-line-graph class="insetGraph" :userId="$store.state.user.scope.user_id"></insulin-line-graph>
    <mu-row class="content" gutter v-if="$store.state.user.scope">
      <mu-col desktop="30" tablet="50" width="100">
        <insulin-input style="margin-top: 24px"></insulin-input>
        <tracking-exporter
          type="insulin"
        ></tracking-exporter>
        <tracking-notifier
          :userId="$store.state.user.scope.user_id"
        ></tracking-notifier>
      </mu-col>
      <mu-col desktop="70" tablet="50" width="100">
        <mu-card
          style="margin-top: 24px;"
          id="blood-glucose-data"
          class="tracking-data"
        >
          <mu-card-text>
            <p class="tracking-subtext" v-text="$t('message.trackingHelpText')"></p>
          </mu-card-text>
          <mu-timeline>
            <div v-for="group, groupKey in groupFilter()" :key="'group-key-' + groupKey" style="margin-bottom: 16px;">
              <div v-for="titleItem, titleIndex in group" :key="'title-index-' + titleIndex" v-if="titleIndex === 0"
                   class="timelineSpacing">
                <div class="bold timelineTitle groupedDate"
                     v-text="groupedDateFormat(titleItem.date_created)">
                </div>
              </div>
              <div v-for="item, index in group" class="timelineSpacing" :key="'tracking-timeline-item-' + index" v-bind:class="{notEditMode: !item.isEditMode}">
                <mu-timeline-item
                  :iconColor="btnColor(item)"
                  iconLine="8"
                  iconType="solid"
                  @click.native="showItemControls(item)"
                >
                  <div v-if="!item.isEditMode" v-bind:class="{spacingBottom: item.isControlsVisible}">
                    <mu-row>
                      <mu-col>
                        <div class="trackingDate" v-if="!item.isEditMode"
                             v-text="groupedItemDate(item.date_created)"></div>
                        <div>{{mapInsulinTypes(item.type_name)}}</div>
                      </mu-col>
                      <mu-col>
                        <div v-if="!item.isEditMode" class="reading">
                          {{item.units + ' ' + lowerCaseUnitsLabel}}
                        </div>
                      </mu-col>
                    </mu-row>
                  </div>
                  <div v-if="item.isControlsVisible === true && !item.isEditMode">
                    <mu-flat-button
                      :color="btnColor('')"
                      :label="$t('message.editText')"
                      icon="edit"
                      @click.native="editReading(item)"
                    >
                    </mu-flat-button>
                    <mu-flat-button
                      :color="btnColor('')"
                      :label="$t('message.deleteText')"
                      icon="delete"
                      @click.native="deleteReading(item)"
                    ></mu-flat-button>
                  </div>
                  <div v-if="item.isEditMode">
                    <insulin-edit
                      @updateReading="updateReading"
                      @closeEditPanel="closeEditMode(item)"
                      :insulinTypes="insulinTypes"
                      :item="item">
                    </insulin-edit>
                  </div>
                </mu-timeline-item>
              </div>
            </div>
          </mu-timeline>
          <mu-card-text align=" center" v-if="isReadingsLoading">
            <mu-circular-progress color="#0179d5"></mu-circular-progress>
            <div v-text="$t('message.loadingText')"></div>
          </mu-card-text>
          <div v-if="!isReadingsLoading" ref="detector"></div>
        </mu-card>
      </mu-col>
    </mu-row>
  </div>
</template>
<script>


  import InsulinApi from "../../api/Tracking/Insulin";
  import InsulinLineGraph from "../../components/Tracking/Graphs/Insulin/LineGraph.vue";
  import InsulinInput from "../../components/Tracking/Input/Insulin/Insulin.vue";
  import TrackingDetailMixin from '../../mixins/TrackingDetailMixin'
  import InsulinEdit from "../../components/Tracking/Edit/Insulin/InsulinEdit.vue";
  import TrackingNotifier from "../../components/TrackingNotifier/TrackingNotifier.vue";
  import TrackingExporter from "../../components/Tracking/Exporter/Exporter.vue";
  import InsulinMixin from '../../mixins/InsulinMixin';


  let fromDate = moment().subtract(1, 'month');
  let toDate = moment();

  export default {
    mixins: [
      TrackingDetailMixin,
      InsulinMixin
    ],
    components: {
      TrackingExporter,
      TrackingNotifier,
      InsulinEdit,
      InsulinInput,
      InsulinLineGraph
    },
    data() {
      return {
        insulinTypes: []
      }
    },
    mounted() {
      let self = this;
      self.$gtag.pageview('/tracking/insulin');

      InsulinApi.getInsulinTypes()
        .then(function (response) {
          self.insulinTypes = response.data;
        });

      self.$EventBus.$on('insulinPusherReceived', function () {
        self.getData();
      });

      self.getData();
    },
    methods: {
      updateReading(reading) {
        let self = this;

        let currentReading = self.data.data.filter((item) => {
          return item.progress_id === reading.progress_id;
        })[0];

        currentReading.units = reading.units;
        currentReading.type = reading.type;
        currentReading.type_name = reading.type_name;
        currentReading.date_created = reading.date_created;

        const typeId = currentReading.type;
        const findInsulinType = self.insulinTypes.filter((item) => {
          return item.insulin_type_id === reading.type;
        })[0];

        currentReading.type_name = findInsulinType.type;
        self.$forceUpdate();

      },
      deleteReading(reading) {
        let self = this;
        let swal = self.$alert;
        self.$alert({
          title: self.$t('message.confirmRemoveTitle'),
          text: self.$t('message.confirmRemoveInsulinItem'),
          type: "warning",
          showCancelButton: true,
          showLoaderOnConfirm: false,
          confirmButtonColor: "white",
          cancelButtonColor: "white",
          preConfirm: function () {
            return InsulinApi.deleteInsulinTracking(reading.progress_id, reading.tracking_id)
          }
        })
          .then(function (response) {
            let index = self.data.data.indexOf(reading);
            self.data.data.splice(index, 1);
            self.$alert({
              title: self.$t('message.labelSuccess'),
              text: self.$t('message.confirmedRemoveInsulinItem'),
              type: "success",
              showCancelButton: false,
              confirmButtonColor: "white"
            });
          }.bind(self))
          .catch(self.$alert.noop)
      },
      getData() {
        let self = this;
        InsulinApi.getInsulinTrackingDetail(1, 15)
          .then(function (response) {
            self.data = response.data;
            self.isReadingsLoading = false;
          })
      },
      loadMoreData() {
        let self = this, page = self.data.page, pages = self.data.pages;
        if (page >= pages) {
          self.isReadingsLoading = false;
          return;
        }
        if ((page < pages)) {
          self.isReadingsLoading = true;
          page++;
          InsulinApi.getInsulinTrackingDetail(page, 15)
            .then(function (response) {
              self.data.page = response.data.page;
              self.data.data.push.apply(self.data.data, response.data.data);
              self.isReadingsLoading = false;
            })
        }
      },
      btnColor(item) {
        if (item.type_name === 'Basal') {
          return '#34CAB9'
        }
        if (item.type_name === 'Bolus') {
          return '#9838C5';
        }

        if (item.type_name === 'Correction') {
          return '#A5DD85'
        }
        else {
          return "#00CBB4"
        }
      }
    },
    beforeDestroy() {
      this.$EventBus.$off('insulinReadingAdded');
    }
  }
</script>
<style lang="less">

  @import "./styles/trackingDetail.css";
  @bgBranding: #00B8C9;

  .timelineSpacing.notEditMode:hover {
    background: fade(@bgBranding, 10%);
    cursor: pointer;
  }

  .whiteTitle {
    font-size: 18px !important;
    color: white !important;

  }
</style>



// WEBPACK FOOTER //
// Insulin.vue?5458a75e